// extracted by mini-css-extract-plugin
module.exports = {"container":"container--DayView-views-Calendar-routes__3siVO"};